// src/Pages/Dashboard/Invoices.jsx
import React, { useState } from "react";
import { useInvoices } from "../../context/InvoicesContext";
import { Link, useNavigate } from "react-router-dom";
import "./Invoices.css";

const Invoices = () => {
  const { invoices } = useInvoices();
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const filteredInvoices = invoices.filter(
    (inv) =>
      inv.invoiceNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      inv.customerName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getStatusColor = (status) => {
    switch (status) {
      case "PAID":
        return "bg-green-100 text-green-800";
      case "DRAFT":
        return "bg-gray-100 text-gray-800";
      case "SENT":
        return "bg-blue-100 text-blue-800";
      case "OVERDUE":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // ← FIXED: Use _id
  const handleRowClick = (invoice) => {
    navigate(`/sales/invoices/${invoice._id}`);
  };

  const formatCurrency = (amount) => {
    return Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="invoice-wrapper">
      <div className="invoices-container">
        <div className="invoices-header">
          <h1>All Invoices</h1>
          <div className="header-actions">
            <input
              type="text"
              placeholder="Search invoices..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Link to="/sales/invoices/new">
              <button className="new-invoice-btn">
                <span>+</span> New
              </button>
            </Link>
          </div>
        </div>

        <div className="invoices-list-full">
          <div className="table-header-row1">
            <span></span>
            <span>DATE</span>
            <span>INVOICE#</span>
            <span>ORDER NUMBER</span>
            <span>CUSTOMER NAME</span>
            <span>STATUS</span>
            <span>DUE DATE</span>
            <span>AMOUNT</span>
            <span>BALANCE DUE</span>
          </div>

          {filteredInvoices.map((inv) => (
            <div
              key={inv._id}
              className="invoice-row"
              onClick={() => handleRowClick(inv)}
            >
              <input type="checkbox" onClick={(e) => e.stopPropagation()} />
              <span data-label="Date">
                {new Date(inv.invoiceDate).toLocaleDateString("en-IN")}
              </span>
              <span data-label="Invoice#" className="invoice-no">
                {inv.invoiceNo}
              </span>
              <span data-label="Order#">{inv.orderNo || "-"}</span>
              <span data-label="Customer">{inv.customerName}</span>
              <span
                data-label="Status"
                className={`status-badge ${getStatusColor(inv.status)}`}
              >
                {inv.status}
              </span>
              <span data-label="Due Date">
                {new Date(inv.dueDate).toLocaleDateString("en-IN")}
              </span>
              <span data-label="Amount">₹{formatCurrency(inv.amount)}</span>
              <span data-label="Balance Due">
                ₹{formatCurrency(inv.balanceDue)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Invoices;
